var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16663 8V12H4.83329V8H6.16663ZM7.49996 12C7.32315 12 7.15358 11.9298 7.02856 11.8047C6.90353 11.6797 6.83329 11.5101 6.83329 11.3333V8C6.83329 7.81667 6.90663 7.65 7.02996 7.53L9.22329 5.33333L9.57663 5.68667C9.66663 5.77667 9.72329 5.9 9.72329 6.04L9.71329 6.14333L9.39663 7.66667H11.5C11.87 7.66667 12.1666 7.96667 12.1666 8.33333V9C12.1666 9.08667 12.15 9.16667 12.12 9.24333L11.1133 11.5933C11.0133 11.8333 10.7766 12 10.5 12H7.49996ZM7.49996 11.3333H10.51L11.5 9V8.33333H8.57329L8.94996 6.56L7.49996 8.01V11.3333Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.16663 3V7H0.833293V3H2.16663ZM3.49996 7C3.32315 7 3.15358 6.92976 3.02856 6.80474C2.90353 6.67971 2.83329 6.51014 2.83329 6.33333V3C2.83329 2.81667 2.90663 2.65 3.02996 2.53L5.22329 0.333334L5.57663 0.686667C5.66663 0.776667 5.72329 0.900001 5.72329 1.04L5.71329 1.14333L5.39663 2.66667H7.49996C7.86996 2.66667 8.16663 2.96667 8.16663 3.33333V4C8.16663 4.08667 8.14996 4.16667 8.11996 4.24333L7.11329 6.59333C7.01329 6.83333 6.77663 7 6.49996 7H3.49996ZM3.49996 6.33333H6.50996L7.49996 4V3.33333H4.57329L4.94996 1.56L3.49996 3.01V6.33333Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(12.5 13) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(8.5 8) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleThumbUp);
export default __webpack_public_path__ + "static/media/double-thumb-up.f03ab796.svg";
export { ForwardRef as ReactComponent };